import React, { Component } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';

import IconButton from 'components/common/IconButton';
import IconPen from 'components/icons/IconPen';
import ClaimAdjustmentCodeCreateEditDialog from 'components/settings/ClaimAdjustmentCodeCreateEditDialog';
import Link from 'components/common/Link';

import splitLongWords from 'utils/splitLongWords';

const styles = () => ({
  buttonCell: {
    textAlign: 'right',
    padding: '0 10px 0 0',
    '&:last-child': {
      padding: '0 10px 0 0',
    },
  },
  iconPen: {
    width: 16,
    height: 16,
  },
  cellType: {
    textTransform: 'capitalize',
  },
  link: {
    wordBreak: 'normal',
  },
});

class ClaimAdjustmentCodesTableRow extends Component {
  constructor(props) {
    super(props);

    this.state = {
      editDialogOpen: false,
    };

    this.onEditMenuItemClick = this.onEditMenuItemClick.bind(this);
    this.onEditDialogClose = this.onEditDialogClose.bind(this);
  }

  onEditMenuItemClick() {
    this.setState({
      editDialogOpen: true,
    });
  }

  onEditDialogClose() {
    this.setState({ editDialogOpen: false });
  }

  render() {
    const { Code, Description, classes } = this.props;
    const { editDialogOpen } = this.state;

    return (
      <TableRow>
        <TableCell>
          <Link
            className={classes.link}
            onClick={this.onEditMenuItemClick}
          >
            {Code}
          </Link>
        </TableCell>
        <TableCell className={classes.cellType}>
          {this.props['Const Type']}
        </TableCell>
        <TableCell>
          {splitLongWords(Description)}
        </TableCell>
        <TableCell className={classes.buttonCell}>
          <IconButton
            onClick={this.onEditMenuItemClick}
            tooltipContent="Edit"
          >
            <IconPen className={classes.iconPen} />
          </IconButton>
        </TableCell>
        <ClaimAdjustmentCodeCreateEditDialog
          form={`claimAdjustmentCodeEdit-${this.props.ID}`}
          open={editDialogOpen}
          ID={this.props.ID}
          initialValues={{
            Code,
            Description,
          }}
          onClose={this.onEditDialogClose}
          onSubmitSuccess={this.onEditDialogClose}
        />
      </TableRow>
    );
  }
}

ClaimAdjustmentCodesTableRow.propTypes = {
  ID: PropTypes.number.isRequired,
  Code: PropTypes.string.isRequired,
  Description: PropTypes.string,
  classes: PropTypes.shape({
    buttonCell: PropTypes.string.isRequired,
    iconPen: PropTypes.string.isRequired,
  }).isRequired,
};

ClaimAdjustmentCodesTableRow.defaultProps = {
  Description: null,
};

export default withStyles(styles)(ClaimAdjustmentCodesTableRow);



// WEBPACK FOOTER //
// ./src/components/settings/ClaimAdjustmentCodesTable/ClaimAdjustmentCodesTableRow.js